import React from 'react';
import styles from './CreateNewWorkSchedule.module.scss';
import { Form, Input } from 'antd';
import Btn from '../../../../../../components/btn';
import cn from 'classnames';

const CreateNewWorkScheduleNode = ({
  form,
  isSubmitting,
  schedule,
  onCancel,
  onSubmit,
}) => {
  const { getFieldDecorator, validateFields } = form;

  const handleSubmit = (event) => {
    event.preventDefault();

    validateFields((errors, values) => {
      if (errors) {
        return;
      }

      if (typeof onSubmit === 'function') {
        const submitValues = {
          name: values.name,
        };

        if (schedule?.id !== undefined && schedule?.id !== null) {
          submitValues.id = schedule.id;
        }

        onSubmit(submitValues);
      }
    });
  };

  return (
    <div className={styles.root}>
      <Form className={styles.createNewSchedule} onSubmit={handleSubmit}>
        <Form.Item className={styles.formItem}>
          {getFieldDecorator('name', {
            initialValue: schedule?.departmentName || schedule?.name || '',
            rules: [
              {
                required: true,
                whitespace: true,
                message: 'Введите наименование графика',
              },
            ],
          })(
            <Input
              className={styles.input}
              placeholder="Наименование графика"
            />
          )}
        </Form.Item>
        <Btn
          className={cn(styles.btn, styles.btn_cancel)}
          disabled={isSubmitting}
          htmlType="button"
          onClick={onCancel}
          type="primary-invert"
        >
          Отмена
        </Btn>
        <Btn
          className={styles.btn}
          disabled={isSubmitting}
          htmlType="submit"
          loading={isSubmitting}
          type="primary"
        >
          {schedule ? 'Сохранить' : 'Сохранить и продолжить'}
        </Btn>
      </Form>
    </div>
  );
};

export const CreateNewWorkSchedule = Form.create({
  name: 'create_new_work_schedule',
  onValuesChange: (props, changedValues, allValues) => {
    const hasValues = Object.values(allValues).some((value) => {
      if (typeof value === 'string') {
        return Boolean(value.trim());
      }

      return value !== undefined && value !== null;
    });

    if (typeof props.onDirtyChange === 'function') {
      props.onDirtyChange(hasValues);
    }
  },
})(CreateNewWorkScheduleNode);
